
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/social-video",
      function () {
        return require("private-next-pages/social-video.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/social-video"])
      });
    }
  